import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface DateRangeFilterProps {
  dateFrom: string;
  dateTo: string;
  onDateFromChange: (value: string) => void;
  onDateToChange: (value: string) => void;
  label?: string;
}

/**
 * Atom: Date range filter with Bolivia locale formatting
 * Displays dates in dd/mm/yyyy format and handles UTC conversion
 */
export function DateRangeFilter({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  label = "Fecha de creación",
}: DateRangeFilterProps) {
  const hasActiveFilters = dateFrom || dateTo;

  const handleReset = () => {
    onDateFromChange("");
    onDateToChange("");
  };

  // Format date from yyyy-mm-dd to dd/mm/yyyy for display
  const formatDateForDisplay = (isoDate: string): string => {
    if (!isoDate) return "";
    const [year, month, day] = isoDate.split("-");
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
      <label className="whitespace-nowrap text-sm font-medium">
        {label}:
      </label>
      <div className="flex flex-col gap-2 sm:flex-row">
        <div className="relative flex flex-col">
          <input
            type="date"
            value={dateFrom}
            onChange={(e) => onDateFromChange(e.target.value)}
            className="h-9 w-full rounded-md border border-input bg-background px-3 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 dark:[color-scheme:dark] sm:w-auto"
            placeholder="Desde"
            lang="es-BO"
          />
          {dateFrom && (
            <span className="sr-only">
              Desde: {formatDateForDisplay(dateFrom)}
            </span>
          )}
        </div>
        <div className="relative flex flex-col">
          <input
            type="date"
            value={dateTo}
            onChange={(e) => onDateToChange(e.target.value)}
            className="h-9 w-full rounded-md border border-input bg-background px-3 text-sm ring-offset-background focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 dark:[color-scheme:dark] sm:w-auto"
            placeholder="Hasta"
            lang="es-BO"
          />
          {dateTo && (
            <span className="sr-only">
              Hasta: {formatDateForDisplay(dateTo)}
            </span>
          )}
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleReset}
            className="h-9 px-2 text-xs"
            title="Limpiar fechas"
          >
            <X className="size-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
